import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { TbFolders } from 'react-icons/tb'
import { useParams, useSearchParams } from 'react-router-dom'

import { DiskScreen } from '../Components/DiskScreen'
import { DISK_FILE_PARAM, parseDiskLocation } from '../Helpers/diskRoutes'
import { diskBrowserStore as store } from '../Stores/DiskBrowserStore'
import { fileViewerStore } from '../Stores/FileViewerStore'
import { withDiskFeature } from '../Helpers/diskFeature'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * Простір, папка, нещодавні чи кошик — за адресою `/disk/:storage/:folder?`
 * (`Helpers/diskRoutes`). Файл у переглядачі — параметр `?file=`.
 */
const BrowserPage = observer(() => {
    const { storage, folder } = useParams()
    const [searchParams, setSearchParams] = useSearchParams()
    const file = searchParams.get(DISK_FILE_PARAM)

    useEffect(() => {
        const location = parseDiskLocation(storage, folder)
        if (location) void store.open(location)
    }, [storage, folder])

    // `?file=` керує переглядачем: гортання й закриття міняють адресу (без нового запису в історії)
    useEffect(() => {
        if (!file) {
            fileViewerStore.detachRoute()

            return
        }

        fileViewerStore.open(file, {
            siblings: () => store.visibleItems,
            onNavigate: (uuid) =>
                setSearchParams(
                    (current) => {
                        const next = new URLSearchParams(current)

                        if (uuid === null) next.delete(DISK_FILE_PARAM)
                        else next.set(DISK_FILE_PARAM, uuid)

                        return next
                    },
                    { replace: true }
                ),
        })
    }, [file, setSearchParams])

    // Пішли з диска — переглядач, відкритий адресою, закривається разом з екраном
    useEffect(() => () => fileViewerStore.detachRoute(), [])

    return <DiskScreen />
})

export default withDiskFeature(BrowserPage)

export const pageConfig: IPageConfig = {
    key: 'Disk.Browser',
    route: '/disk/:storage/:folder?',
    title: 'Диск',
    icon: <TbFolders />,
}
